module.exports = __webpack_public_path__ + "static/img/Mitch_McGovern_desktop.0fcb942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mitch_McGovern_desktop.jpg
// module id = zE4X
// module chunks = 0